import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../../../../src/constants';

export default StyleSheet.create({
  flag: {
    borderWidth: 1,
    borderColor: PALETTE.secondaryActive,
    backgroundColor: PALETTE.secondaryBackground,
    paddingHorizontal: 10,
    paddingVertical: 2,
    zIndex:100,

    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flagDate: {
    color: PALETTE.secondaryText,
    textAlign: 'right',
  },
  flagPrice: {
    color: PALETTE.secondaryActive,
    textAlign: 'right',
  }
});
